import React from "react";
import { useRef } from "react";
import JoditEditor from "jodit-react";

interface EditorProps {
  content: string;
  setContent: (newContent: string) => void;
  config?: Record<string, any>;
}

const Editor: React.FC<EditorProps> = ({ content, setContent, config }) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={content}
      config={config}
      onBlur={(newContent) => setContent(newContent)}
      onChange={() => {}}
    />
  );
};

export default Editor;
